import { useContext, useState } from "react";
import { Button, Title } from "react-admin";
import { GridLayoutWidget } from "../../assets/maintenance-dashboard/common";
import { Breadcrumb } from "./Breadcrumb";
import { SelectedDriversFilterContext } from "./common";
import { SelectedDriversSlide } from "./SelectedDriversSlide";
import { TotalDrivers } from "./widgets/TotalDrivers";
import { HarshEventsBreakdown } from "./widgets/HarshEventsBreakdown";
import "./SafetyDashboard.css";
import { DriversScore } from "./widgets/DriversScore";
import { GeometrisAlerts } from "./widgets/GeometrisAlerts";
import { SpeedingEventsSummary } from "./widgets/SpeedingEventsSummary";
import { CloudDownloadOutlined } from "@material-ui/icons";
import { RouteComponentProps } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { SafetyReport } from "../../reports/safety/SafetyReport";

const widgets: GridLayoutWidget[] = [
  {
    i: "harshEvents",
    Widget: HarshEventsBreakdown,
    icon: "warning",
    title: "Drivers with harsh events",
  },
  {
    i: "totalDrivers",
    Widget: TotalDrivers,
    icon: "info",
    title: "Active drivers",
  },
  {
    i: "safetyScore",
    Widget: DriversScore,
    icon: "info",
    title: "Drivers safety score",
  },
  {
    i: "geometrisAlerts",
    Widget: GeometrisAlerts,
    icon: "warning",
    title: "Harsh events",
  },
  {
    i: "speedingLocations",
    Widget: SpeedingEventsSummary,
    icon: "error",
    title: "Speeding summary",
  },
];

interface Props extends RouteComponentProps {}
export const SafetyDashboard = (props: Props) => {
  const [isReportOpen, setIsReportOpen] = useState(false);
  const context = useContext(SelectedDriversFilterContext);
  const sidebarVisible = !!context?.selectedFilter;
  return (
    <>
      <Title title={<Breadcrumb />} />
      <div className="safety-dashboard-wrapper">
        <div className="btn-wrapper">
          <Button
            onClick={() => setIsReportOpen(true)}
            variant="contained"
            label="Download"
          >
            <CloudDownloadOutlined />
          </Button>
        </div>
        <div className="safety-dashboard">
          {widgets.map((x) => (
            <x.Widget key={x.i} icon={x.icon} title={x.title} />
          ))}
          {sidebarVisible ? <SelectedDriversSlide /> : null}
        </div>
      </div>
      <Dialog
        fullWidth
        maxWidth="md"
        open={isReportOpen}
        onClose={() => setIsReportOpen(false)}
        scroll="paper"
      >
        <DialogTitle>Safety report</DialogTitle>
        <DialogContent
          style={{
            maxHeight: "80vh",
            overflow: "auto",
            padding: "24px",
          }}
        >
          <SafetyReport {...props} isDialog />
        </DialogContent>
      </Dialog>
    </>
  );
};
